<div class="font-bold mb-3" style="font-size: 1.2rem">{{ 'HELP' | translate }}</div>

<p-card>
  <p-tabs [value]="activeTab">
    <p-tablist>
      @for (tab of tabs; track $index) {
        <p-tab [value]="$index">{{ tab | translate }}</p-tab>
      }
    </p-tablist>
    <p-tabpanels>
      @for (tab of tabs; track $index) {
        <p-tabpanel [value]="$index">
          @if (tab == 'global.faq') {
            <app-faq [FAQs]="listFAQs"></app-faq>
          } @else if (tab == 'global.contact') {
            <app-contact></app-contact>
          } @else {
            <app-documentation></app-documentation>
          }
        </p-tabpanel>
      }
    </p-tabpanels>
  </p-tabs>
</p-card>